































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { deleteElement } from "@/api/delite/delite-element";
import { channels as tv } from "@/config/host.config";
import { channelTypes } from "@/config/channels/channel-types.config.json";
import { IChannel } from "@/@types/channels/channels";
import { IContentType } from "@/@types/channels/content-type";

import FullChannelList from "@/components/tables/channels/full-channel-list.vue";
import IpStreamChannels from "@/components/tables/channels/ip_stream_channels.vue";
import ChannelListHeader from "@/components/tables/channels/channel-list-header.vue";
import FullChannelCard from "@/components/tabs/channels/full-channel-card.vue";
import ChangeChannelModal from "@/components/tabs/channels/change-channel-modal.vue";
import Dictionary from "@/components/app/dictionary.vue";

interface ISortColumn {
  name: number;
  channelType: number;
  show: number;
  sort_order: number;
}

@Component({
  components: {
    channels: FullChannelList,
    IpStreamChannels,
    "ch-header": ChannelListHeader,
    "channel-card": FullChannelCard,
    ChangeChannelModal,
    Dictionary,
  },
})
export default class ChannelsList extends Vue {
  @Prop({ type: String, default: "tv" }) activeType!: string;
  @Prop({ type: Array, default: () => [] }) contentTypes!: Array<IContentType>;

  channelList: Array<IChannel> = [];
  deleted = false;
  channel_id = "";
  seartch = "";
  sortKey = "";
  loading = false;
  sortOrder: ISortColumn = {
    name: -1,
    show: -1,
    sort_order: -1,
    channelType: -1,
  };

  get channel(): IChannel | null {
    const channel = this.channelList.find((el) => el._id == this.channel_id);
    return channel ? channel : null;
  }

  get channels(): Array<IChannel> {
    const filterKey = this.seartch && this.seartch.toLowerCase();
    const order = this.sortOrder[this.sortKey as keyof ISortColumn] || 1;

    if (filterKey) {
      return this.channelList
        .filter(
          (ch) => ch.name.toLowerCase().indexOf(filterKey.toLowerCase()) > -1
        )
        .sort((a, b) =>
          b.show === a.show ? a.sort_order - b.sort_order : b.show ? 1 : -1
        );
    }

    let channelList = this.channelList;
    if (!this.sortKey) {
      return channelList
        .slice()
        .sort((a, b) =>
          b.show === a.show ? a.sort_order - b.sort_order : b.show ? 1 : -1
        );
    }

    if (this.sortKey == "name") {
      channelList = channelList.slice().sort((a: IChannel, b: IChannel) => {
        const one = a.name;
        const two = b.name;
        return (one === two ? 0 : one > two ? 1 : -1) * order;
      });
    }
    if (this.sortKey == "channelType") {
      channelList = channelList.slice().sort((a: IChannel, b: IChannel) => {
        const one = a.data?.channelType;
        const two = b.data?.channelType;
        return (one === two ? 0 : one > two ? 1 : -1) * order;
      });
    }
    if (this.sortKey == "sort_order") {
      channelList = channelList.slice().sort((a: IChannel, b: IChannel) => {
        const one = a.sort_order;
        const two = b.sort_order;
        return (one === two ? 0 : one > two ? 1 : -1) * order;
      });
    }
    if (this.sortKey == "show") {
      channelList = channelList.slice().sort((a: IChannel, b: IChannel) => {
        const one = a.show;
        const two = b.show;
        return (one === two ? 0 : one > two ? 1 : -1) * order;
      });
    }

    return channelList;
  }

  sortBy(key: string): void {
    this.sortKey = key;
    this.sortOrder[key as keyof ISortColumn] =
      this.sortOrder[key as keyof ISortColumn] * -1;
  }

  isOpen(id: string): void {
    this.channel_id = id;
    this.$nextTick(() => this.$bvModal.show("channel-card"));
  }

  isChangeOpen(id: string): void {
    this.channel_id = id;
    this.$nextTick(() => this.$bvModal.show("change-channel-modal"));
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  onSuccess(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.200")),
    });
  }

  async deleteChannel(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("ChannelsPage.confirm.delete")),
        }
      );
      if (result === true) {
        this.$bvModal.hide("channel-card");
        const uri = this.deleted ? tv.forceDelete : tv.mainAPI;
        deleteElement(id, uri)
          .then(() => {
            this.onSuccess();
            this.deleteChannelFromList(id);
          })
          .catch((e) => {
            console.error(e);
            this.onError();
          });
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  async deleteChannelFromList(id: string): Promise<void> {
    const i = this.channelList.findIndex((el) => el._id == id);
    if (i < 0) return this.createChannels();
    this.channelList.splice(i, 1);
  }

  async restoreChannel(id: string): Promise<void> {
    try {
      const res = await this.$axios.put(`${tv.restore}/${id}`);
      if (res.status === 200) {
        this.onSuccess();
        this.deleteChannelFromList(id);
      }
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  /**
   * @params type: 1 - tv channels
   * @params type: 2 - radios channels
   * @params type: 3 - cameras
   * @params type: 4 - ip stream
   */
  @Watch("activeType")
  @Watch("deleted")
  async createChannels(): Promise<void> {
    this.loading = true;
    const i = channelTypes.findIndex((t) => t == this.activeType);
    const typeid = i < 0 ? 1 : i + 1;

    const params = {
      "projection[_id]": 1,
      "projection[name]": 1,
      "projection[image]": 1,
      "projection[data]": 1,
      "projection[sort_order]": 1,
      "projection[language]": 1,
      "projection[type]": 1,
      "projection[content_type]": 1,
      "projection[show]": 1,
      "projection[logical_number_on_linked_tv]": 1,
      "match[type]": typeid,
      "match[deleted][value]": this.deleted,
    };

    try {
      const res = await this.$axios.get(tv.allChannels, { params });
      if (res.status === 200) {
        this.$log_info(`channels type ${this.activeType}: `, res.data.length);
        this.channelList = res.data;
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  async updateChannel(data: Partial<IChannel>, id: string): Promise<void> {
    const uri = id ? tv.mainAPI + id : tv.mainAPI;
    const method = id ? "put" : "post";
    this.channel_id = "";
    try {
      const ch_res = await this.$axios[method](uri, data);
      if (ch_res.status === 200) {
        this.onSuccess();
        this.$bvModal.hide("change-channel-modal");
        const i = this.channelList.findIndex((c) => c._id == id);
        if (i < 0) {
          this.channelList.push(ch_res.data);
          return;
        }
        const data = ch_res.data;
        data._id = id;
        this.$set(this.channelList, i, data);
      }
    } catch (e) {
      console.error(e);
      this.onError();
    }
  }

  mounted(): void {
    this.createChannels();
  }
}
